const MockData = {
  mgmReferralCode: 'MGM-ppdhjjnww',
  mgmStatus: 'ACTIVE',
  mgmReferralCreationDate: '2024-07-30 09:18:41',
  maxGodsonsReferral: 30,
  referrals: [
    {
      referralDate: '2024-08-01 09:18:41'
    },
    {
      referralDate: '2024-08-20 09:18:41'
    },
    {
      referralDate: '2024-08-24 09:18:41'
    },
    {
      referralDate: '2024-08-01 09:18:41'
    },
    {
      referralDate: '2024-08-20 09:18:41'
    },
    {
      referralDate: '2024-08-24 09:18:41'
    }
  ],
  rewards: [
    {
      type: 'voucher',
      value: '10%',
      couponCode: 'Referral1-XXXX-XXXX',
      loyaltyPoints: null,
      expirationDate: '2025-10-04 09:18:41',
      burnedDate: '2024-08-30 09:18:41',
      referralDate: '2024-08-30 09:18:41'
    },
    {
      type: 'voucher',
      value: '50$',
      couponCode: 'Referral2-XXXX-XXXX',
      loyaltyPoints: null,
      expirationDate: '2024-10-18 09:18:41',
      burnedDate: '',
      referralDate: '2024-10-18 09:18:41'
    },
    {
      type: 'voucher',
      value: '20$',
      couponCode: 'Referral3-XXXX-XXXX',
      loyaltyPoints: null,
      expirationDate: '2025-10-18 09:18:41',
      burnedDate: '',
      referralDate: '2025-10-18 09:18:41'
    },
    {
      type: 'voucher',
      value: '20$',
      couponCode: 'Referral3-XXXX-XXXX',
      loyaltyPoints: null,
      expirationDate: '',
      burnedDate: '',
      referralDate: ''
    },
    {
      type: 'loyalty',
      value: 'Refer a Friend 01',
      couponCode: '',
      loyaltyPoints: 100,
      expirationDate: '2025-10-30 09:18:41',
      burnedDate: '',
      referralDate: '2024-10-29 09:23:54'
    },
    {
      type: 'loyalty',
      value: 'Refer a Friend 02',
      couponCode: '',
      loyaltyPoints: 200,
      expirationDate: '2024-10-30 09:18:41',
      burnedDate: '',
      referralDate: '2024-10-29 09:23:54'
    },
    {
      type: 'loyalty',
      value: 'Refer a Friend 03',
      couponCode: '',
      loyaltyPoints: 300,
      expirationDate: '',
      burnedDate: '2024-10-30 09:18:41',
      referralDate: '2024-10-29 09:23:54'
    }
  ]
}

export default MockData
